import { Navigate } from "react-router-dom";

// Hauptlayout laden
import LayoutMain from "./components/LayoutMain";

import Home from "./pages/Home";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Products from "./pages/Products";
import Wine from "./pages/Wine";
import Spirits from "./pages/Spirits";
import Cart from "./pages/Cart";
import Beer from "./pages/Beer";
import ProductsDetail from "./pages/ProductsDetail";
import AddProduct from "./pages/AddProduct";
import EditProduct from "./pages/EditProduct";
import Checkout from "./pages/Checkout";

const routesPublic = [
  {
    path: "",
    // Layoutelement
    element: <LayoutMain />,
    children: [
      { path: "", exact: true, element: <Home /> },
      { path: "login", element: <Login /> },
      { path: "signup", element: <Signup /> },
      { path: "wine", element: <Wine /> },
      { path: "beer", element: <Beer /> },
      { path: "all-products", element: <Products /> },
      { path: "spirits", element: <spirits /> },
      { path: "detail", element: <ProductsDetail /> },
      { path: "*", element: <Navigate to="/" /> },
    ],
  },
];
const routesUserLogedIn = [
  {
    path: "",
    // Layoutelement
    element: <LayoutMain />,
    children: [
      { path: "", exact: true, element: <Home /> },
      { path: "login", element: <Login /> },
      { path: "signup", element: <Signup /> },
      { path: "wine", element: <Wine /> },
      { path: "beer", element: <Beer /> },
      { path: "all-products", element: <Products /> },
      { path: "spirits", element: <Spirits /> },
      { path: "detail", element: <ProductsDetail /> },
      { path: "checkout", element: <Checkout /> },
      { path: "cart", element: <Cart /> },
      { path: "*", element: <Navigate to="/" /> },
    ],
  },
];

const routesAdmin = [
  {
    path: "",
    // Layoutelement
    element: <LayoutMain />,
    children: [
      { path: "", exact: true, element: <Home /> },
      { path: "login", element: <Login /> },
      { path: "signup", element: <Signup /> },
      { path: "wine", element: <Wine /> },
      { path: "beer", element: <Beer /> },
      { path: "all-products", element: <Products /> },
      { path: "spirits", element: <Spirits /> },
      { path: "add-product", element: <AddProduct /> },
      { path: "detail", element: <ProductsDetail /> },
      { path: "checkout", element: <Checkout /> },
      { path: "update", element: <EditProduct /> },
      { path: "cart", element: <Cart /> },
      { path: "*", element: <Navigate to="/" /> },
    ],
  },
];

export default routesPublic;

export { routesPublic, routesAdmin, routesUserLogedIn };
